import { Injectable } from "@angular/core";
import { isDefined } from "../shared/helpers";

@Injectable()
export class EnvironmentService {

  getEnvironmentTag(): string {
    const hostName = window.location.hostname;
    const hostNameparts = hostName.match("^apps(.[A-Za-z]*).moo.nl$");
    if (!isDefined(hostNameparts)) {
      return "";
    } else {
      return hostNameparts![1];//first element in array is the entire hostUrl so we take the second
    }
  }

  isNonProdEnv(): boolean {
    const env = this.getEnvironmentTag();
    if (env === ".dev" || env === ".test") {
      return true;
    } else {
      return false;
    }
  }

  get staticFilesUrl(): string {
    const assetsUrlPattern = "https://apps@env.moo.nl/static-storage/assets/MOO-2.0/Images";
    return assetsUrlPattern.replace("@env", this.getEnvironmentTag());

  }

  get startPortalUrl(): string {
    const startPortalUrlPattern = "https://suite@env.moo.nl/";
    return startPortalUrlPattern.replace("@env", this.getEnvironmentTag());

  }

}